export default "__VITE_ASSET__fd413d0a__"